import React, { useState } from 'react';
import { GlassCard } from '../components/GlassCard';
import { MOCK_ALERTS } from '../data/mockData';
import { Badge } from '../components/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiCheck, FiXCircle } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

export const Alerts = () => {
  const [alerts, setAlerts] = useState(MOCK_ALERTS);

  const acknowledgeAlert = (id) => {
    setAlerts(alerts.map(a => a.id === id ? { ...a, status: 'acknowledged' } : a));
  };

  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Alert Queue</h1>
        <p className="text-slate-400 mt-1">Actionable intelligence from monitored environments.</p>
      </div>

      <div className="space-y-4">
        <AnimatePresence>
          {alerts.map((alert, index) => (
            <motion.div
              key={alert.id}
              layout
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ delay: index * 0.05 }}
            >
              <GlassCard className={`p-4 sm:p-6 transition-all border-l-4 ${
                alert.severity === 'critical' ? 'border-l-red-500' : 
                alert.severity === 'high' ? 'border-l-orange-500' : 
                'border-l-yellow-500'
              } ${alert.status === 'acknowledged' ? 'opacity-60' : ''}`}>
                
                <div className="flex flex-col sm:flex-row justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <Badge type={alert.severity} />
                      <span className="text-sm font-mono text-slate-400 bg-black/50 px-2 py-0.5 rounded">{alert.id}</span>
                      <span className="text-xs text-slate-500 flex items-center gap-1">
                        <SafeIcon icon={FiClock} /> {alert.time}
                      </span>
                    </div>
                    
                    <h3 className="text-xl font-semibold mb-1">{alert.type}</h3>
                    <p className="text-slate-400 text-sm mb-3">{alert.description}</p>
                    
                    <div className="flex items-center gap-2 text-sm">
                      <span className="text-slate-500">Target Asset:</span>
                      <span className="font-mono text-emerald-400 bg-emerald-500/10 px-2 py-0.5 rounded border border-emerald-500/20">
                        {alert.asset}
                      </span>
                    </div>
                  </div>

                  <div className="flex sm:flex-col justify-end gap-2 shrink-0">
                    {alert.status === 'active' ? (
                      <button 
                        onClick={() => acknowledgeAlert(alert.id)}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-lg text-sm transition-colors w-full sm:w-auto"
                      >
                        <SafeIcon icon={FiCheck} />
                        Acknowledge
                      </button>
                    ) : (
                      <div className="flex items-center justify-center gap-2 px-4 py-2 bg-emerald-500/10 text-emerald-500 border border-emerald-500/20 rounded-lg text-sm w-full sm:w-auto cursor-default">
                        <SafeIcon icon={FiCheck} />
                        Acknowledged
                      </div>
                    )}
                    <button className="flex items-center justify-center gap-2 px-4 py-2 text-slate-500 hover:text-slate-300 hover:bg-white/5 rounded-lg text-sm transition-colors w-full sm:w-auto">
                      <SafeIcon icon={FiXCircle} />
                      Dismiss
                    </button>
                  </div>
                </div>
              </GlassCard>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
};